// import { initWafFetch } from './app/utils/wafFetch';

// initWafFetch();

// import { triggerWafCaptcha } from './app/utils/wafCaptchaTest';
// triggerWafCaptcha();

window.global ||= window;
